import { ModalContext, ModalContextType } from "@/lib/main";
import { useContext } from "react";

export default function useModal(): ModalContextType {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalContext.Provider");
  }
  return context;
}
